import { defineComponent as _defineComponent } from 'vue';
import { ref, computed, watch, onMounted } from 'vue';
import { BOverlay } from 'bootstrap-vue';
import debounce from 'lodash/debounce';
import { getSheetPrice } from 'public/modules/pricing';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpsellSheetProduct',
    props: {
        size: null,
        product: null,
        basePrice: null,
        quantity: null
    },
    setup(__props) {
        const props = __props;
        const loading = ref(true);
        const pricing = ref({
            base_unit_price: '0.00',
            ex_vat_base_unit_price: '0.00',
            unit_price: '0.00',
            total_price: '0.00',
            unit_discount: '0.00',
            total_discount: '0.00'
        });
        const priceIncrease = ref('0.00');
        const href = computed(() => {
            const params = new URLSearchParams();
            params.set('widthMM', props.size.width.toString());
            params.set('lengthMM', props.size.length.toString());
            return `/diy-framing/accessories/${props.product.category?.type?.slug}/${props.product.meta?.slug}?${params.toString()}`;
        });
        function calculatePriceIncrease() {
            priceIncrease.value = (parseFloat(pricing.value.unit_price.replace(',', '')) - parseFloat(props.basePrice.replace(',', ''))).toFixed(2);
        }
        const debouncedCalcPrice = debounce(calculatePriceIncrease, 350);
        watch(() => pricing.value.unit_price, debouncedCalcPrice);
        watch(() => props.basePrice, debouncedCalcPrice);
        async function getPrice() {
            if (!props.product.sku || !props.quantity)
                return;
            loading.value = true;
            try {
                const newPricing = await getSheetPrice(props.product.sku, props.size, false, null, props.quantity);
                Object.assign(pricing.value, newPricing);
            }
            catch (e) {
                console.error(e);
            }
            loading.value = false;
        }
        const debouncedGetPrice = debounce(getPrice, 350);
        watch(() => props.quantity, debouncedGetPrice);
        watch(() => props.size, debouncedGetPrice, { deep: true });
        onMounted(() => {
            getPrice();
        });
        return { __sfc: true, props, loading, pricing, priceIncrease, href, calculatePriceIncrease, debouncedCalcPrice, getPrice, debouncedGetPrice, ref, computed, watch, onMounted, BOverlay, debounce, getSheetPrice };
    }
});
